import "./zero_touch_men_section.css";
import compute_mobility from "../../Img/Zero_touch_image/compute_mobility.png";
import zero_touch from "../../Img/Zero_touch_image/zero_touch.png";
import android_enterprise from "../../Img/Zero_touch_image/android_enterprise.png";
import mobile_device_management from "../../Img/Zero_touch_image/mobile_device_management.png";
import enterprise_finance from "../../Img/Zero_touch_image/enterprise_finance.png";
import { Link } from "react-router-dom";
const zero_touch_men_section = () => {
  return (
    <section class="otherProducts">
      <div class="container">
        <div class="otherProducts_heading">
          <h2>
            Harsafe Technology Finance Service - Powering Smarter Android
            Enterprise
          </h2>
        </div>
        <div class="otherProducts_inner">
          <ul>
            <li>
              <Link to="/Zero_touch_section">
                <div class="otherProducts_box">
                  <div class="otherProducts_box_image">
                    <span>
                      <img src={zero_touch} alt="" className="img-fluid" />
                    </span>
                  </div>
                  <p class="Zero-touch-text">Zero touch</p>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/Android_Enterprise">
                <div class="otherProducts_box">
                  <div class="otherProducts_box_image">
                    <span>
                      <img
                        src={android_enterprise}
                        alt=""
                        className="img-fluid"
                      />
                    </span>
                  </div>
                  <p class="Zero-touch-text">Android Enterprise</p>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/deployment_management">
                <div class="otherProducts_box">
                  <div class="otherProducts_box_image">
                    <span>
                      <img
                        src={mobile_device_management}
                        alt=""
                        className="img-fluid"
                      />
                    </span>
                  </div>
                  <p class="Zero-touch-text">Mobile Device Management</p>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/Enterprise_Finance">
                <div class="otherProducts_box">
                  <div class="otherProducts_box_image">
                    <span>
                      <img
                        src={enterprise_finance}
                        alt=""
                        className="img-fluid"
                      />
                    </span>
                  </div>
                  <p class="Zero-touch-text">Enterprise Finance</p>
                </div>
              </Link>
            </li>
            <li>
              <Link to="/Compute_Mobility">
                <div class="otherProducts_box">
                  <div class="otherProducts_box_image">
                    <span>
                      <img
                        src={compute_mobility}
                        alt=""
                        className="img-fluid"
                      />
                    </span>
                  </div>
                  <p class="Zero-touch-text">Compute &amp; Mobility</p>
                </div>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default zero_touch_men_section;
